export enum AcquirerAccountType {
  Debit = 'DEBIT',
  Credit = 'CREDIT',
}
